export const haulRoadAnalyticsTabs = {
  Outputs: 'Outputs',
  Generate: 'Generate',
  Guide: 'Guide',
};
